export default {
      id: "mail-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "sprite-46b249.svg#mail-usage",
      toString: function () {
        return this.url;
      }
    }